import { AvatarFallback, AvatarImage, Avatar as ShadcnAvatar } from '@components/ui/avatar';
import { cn } from '@lib/utils';
import { getAvatarInitials } from '@utils/functions.util';
import React from 'react';

export interface AvatarProps {
  altText: string;
  className?: string;
  colorMode?: 'light' | 'dark';
  fallbackIcon?: React.ReactNode;
  imageUrl?: string;
  initialText?: string;
  size?: 'lg' | 'md' | 'sm';
}

export const Avatar: React.FC<AvatarProps> = (props) => {
  const { altText, className, colorMode = 'light', fallbackIcon, imageUrl, initialText, size = 'md' } = props;
  const avatarInitials = initialText ? getAvatarInitials(initialText) : null;

  const sizeClasses = cn(size === 'sm' && 'h-8 w-8', size === 'md' && 'h-10 w-10', size === 'lg' && 'h-14 w-14');

  const colorClasses =
    colorMode === 'dark'
      ? 'bg-sidebar-accent border-sidebar-border text-sidebar-foreground'
      : 'bg-gray-100 border-gray-300 text-gray-900';

  return (
    <ShadcnAvatar className={cn(sizeClasses, colorClasses, 'border', className)}>
      {imageUrl ? (
        <AvatarImage
          src={imageUrl}
          alt={altText}
        />
      ) : null}
      <AvatarFallback className={cn(sizeClasses, colorClasses, className)}>
        {fallbackIcon !== undefined ? fallbackIcon : avatarInitials}
      </AvatarFallback>
    </ShadcnAvatar>
  );
};
